import { Controller as BaseController } from '@hotwired/stimulus';

export default class extends BaseController {
  static targets = ['sidebar', 'background'];
  static values = { turboFrame: String, turboSrc: String };

  connect() {
    // Garante que a sidebar começa fechada
    this.closeSidebar();
  }

  toggle() {
    if (this.sidebarTarget.classList.contains('tw-translate-x-0')) {
      this.closeSidebar();
    } else {
      this.openSidebar();
    }
  }

  openSidebar() {
    this.sidebarTarget.classList.remove('tw-translate-x-full');
    this.sidebarTarget.classList.add('tw-translate-x-0');

    this.backgroundTarget.classList.remove('tw-hidden');

    // Load turbo frame content if configured
    if (this.hasTurboFrameValue && this.hasTurboSrcValue) {
      this.loadTurboFrameContent();
    }
  }

  closeSidebar() {
    this.sidebarTarget.classList.remove('tw-translate-x-0');
    this.sidebarTarget.classList.add('tw-translate-x-full');

    this.backgroundTarget.classList.add('tw-hidden');
  }

  loadTurboFrameContent() {
    const turboFrame = document.getElementById(this.turboFrameValue);
    if (turboFrame && !turboFrame.hasAttribute('complete')) {
      turboFrame.src = this.turboSrcValue;
      turboFrame.setAttribute('complete', 'true');
    }
  }
}
